import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../../../controllers/AuthController';
import { getAllSetting } from '../../../../controllers/SettingController';
import { useAuth } from '../../../../context/AuthContext';
import { useSetting } from '../../../../context/SettingContext';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import ButtonPrimary from '../../../../components/button/ButtonPrimary';

const Card = ({ t }) => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { updateAuth } = useAuth();
  const { updateSetting } = useSetting();
  
  const handleIdentifierChange = (e) => {
    setIdentifier(e.target.value.toLowerCase());
  };
  
  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };
  
  const isDisabled = useMemo(() => !identifier || !password, [identifier, password]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { user } = await login(identifier, password);
      updateAuth(user);
      
      const result = await getAllSetting();
      updateSetting(result);
      
      navigate('/dashboard'); 
    } catch (error) {
      setError(error);
    };
  };
  
  return (
    <div className='max-w-md p-10 space-y-5 bg-white rounded-lg md:w-screen'>
      <div className='text-center'>
        <h1 className='text-2xl font-bold text-black'>{t('auth.loginTitle')}</h1>
      </div>
      <form className='space-y-5' onSubmit={handleSubmit}>
        <div>
          <label className='block text-xs font-medium text-black'>{t('auth.usernameLabel')}</label>
          <input
            className='w-full mt-2 px-3 py-2 border border-platinum rounded hover:outline-none hover:border-grayX11 focus:outline-none focus:border-blackOlive text-xs'
            type='text'
            placeholder={t('auth.usernamePlaceholder')}
            required
            value={identifier}
            onChange={handleIdentifierChange}
          />
        </div>
        <div className='relative'>
          <label className='block text-xs font-medium text-black'>{t('auth.passwordLabel')}</label>
          <input
            className='w-full mt-2 px-3 py-2 border border-platinum rounded hover:outline-none hover:border-grayX11 focus:outline-none focus:border-blackOlive text-xs'
            type={showPassword ? 'text' : 'password'}
            placeholder={t('auth.passwordPlaceholder')}
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            className='absolute top-8 right-3 flex text-grayX11'
            type='button'
            aria-label={showPassword ? 'Sembunyikan kata sandi' : 'Tampilkan kata sandi'}
            onClick={toggleShowPassword}
          >
            {showPassword ? <VisibilityOffIcon sx={{ fontSize: '1.25rem' }} /> : <VisibilityIcon sx={{ fontSize: '1.25rem' }} />}
          </button>
        </div>
        {error && (
          <div className='w-full flex flex-row items-center p-3 space-x-2 rounded border-2 border-errorMessage'>
            <CancelRoundedIcon className='text-errorMessage' sx={{ fontSize: '1rem' }} />
            <span className='text-xs font-medium text-errorText'>{error.message?.includes('Invalid') ? t('auth.invalidCredentials') : t('auth.genericError')}</span>
          </div>
        )}
        <ButtonPrimary className='w-full' type='submit' isDisabled={isDisabled}>{t('auth.submitButton')}</ButtonPrimary>
      </form>
    </div>
  );
};

export default Card;
